export enum TooltipHeaderDateInBetweenOptions {
    Vs = 'vs',
    To = 'to',
}
